export default "https://statics.cloudfastin.top/static/v1.27.38.2/store/images/new_codedisplay_2_left.png?ee5eff4020da4d97dc072df705e5cb06";